<template>
    <div class="donut-wrapper">
        <div class="name" v-html="this.name"></div>
        <apexchart 
            type='donut'
            :height="chartHeight"
            :options="chartsOptions" 
            :series="series"
        ></apexchart>
    </div>
</template>
<script>

export default {
    name: 'donutChart',
    props: ['series','labels','name','colors'],
    data: () => ({
        chartHeight:185,
        chartsOptions:{
            chart: {
                animations: {
                    enabled: true,
                    easing: 'linear',
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 350
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 500
                    }
                }
            },
            stroke: {
                show: true,
                curve: 'smooth',
                lineCap: 'butt',
                colors: undefined,
                width: 2,
                dashArray: 0,      
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                floating: true,
                fontSize: '12px',
                fontFamily: 'Poppins, Arial',
                fontWeight: 600,
                position: 'bottom',
                offsetY: 60,
                width:190,
                horizontalAlign: 'left',
                markers: {
                    width: 23,
                    height: 18,
                    strokeColor: '#fff',
                    radius: 4,
                },
                itemMargin: {
                    horizontal: 0,
                    vertical: 0
                },
                onItemClick: {
                    toggleDataSeries: false
                },
                onItemHover: {
                    highlightDataSeries: false
                },
            },
            tooltip: {
                y: {}
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    donut: {
                        size: '68%'
                    }
                }
            },
            states: {
                normal: {
                    filter: {
                        type: 'none',
                        value: 0,
                    }
                },
                hover: {
                    filter: {
                        type: 'darken',
                        value: 0.8,
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'none',
                        value: 0,
                    }
                },
            },
        },
    }),
    watch:{
        colors:function(newColors){
            let colorsArr =  newColors.slice();
            let strokeColor = colorsArr.pop();
            this.chartsOptions = {...this.chartsOptions, ...{
                    colors: colorsArr,
                    stroke:{
                        colors:strokeColor
                    }
            }};
        }
    },
    methods:{
        legendFormatter(seriesName, opts) {
            let value = opts.w.globals.series[opts.seriesIndex];
            if (value) value = this.addCommas(value);
            return seriesName + ' <span class="font-normal">' + value +'</span>';
        },
        tooltipFormatter(value){
            return this.addCommas(value);
        },
        checkHeight() {
        //    this.chartHeight = window.innerWidth < 430 ?  170 : 185;
        }
    },
    created(){
        // this.checkHeight();
        let colorsArr =  this.colors.slice();
        let strokeColor = colorsArr.pop();
        this.chartsOptions.colors = colorsArr;
        this.chartsOptions.stroke.colors = strokeColor;
        this.chartsOptions.colors = this.colors;
        this.chartsOptions.labels = this.labels;
        this.chartsOptions.legend.formatter = this.legendFormatter;
        this.chartsOptions.tooltip.y.formatter = this.tooltipFormatter;

        // window.addEventListener('resize', this.checkHeight);
    },  
    beforeDestroy() { 
        // window.removeEventListener('resize', this.checkHeight); 
    }
}
</script>
<style lang="scss">
.donut-wrapper{
    margin-bottom: 65px;
    .name{
        position: absolute;
        z-index: 1;
        text-align: center;
        font-size: 14px;
        color: #C8C8CA;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        @media (max-width: 420px) {
            font-size: 12px;
        }
    }
    &.hideLegend{
        .apexcharts-legend{
            display: none !important;
        }
    }
}
.apexcharts-canvas{
    & > svg,
    & > svg > foreignObject{
        overflow: visible !important;
    }
}
.apexcharts-legend{
    left:50% !important;
    transform: translateX(-50%) !important;
    flex-direction: column !important;

    @media (max-width: 400px) {
        left:60% !important;
    }
    .apexcharts-legend-marker{
        top:4px !important;
        margin-right: 5px !important;
    }
    .apexcharts-legend-text,
    .apexcharts-legend-text > span{
        color:var(--font-color) !important;
    }
}
</style>